import React, { Component } from "react";
import PropTypes from "prop-types";
import { TooltipOverlay } from "~/components";
import OccupantsList from "./OccupantsList";
import classnames from "classnames";
import { ArrowDropDownIcon, OccupantsIcon } from "../../theme/assets";
import styles from "./BookingForm.scss";

class OccupantsWrapper extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleCloseTooltip = this.handleCloseTooltip.bind(this);
  }

  handleClick() {
    this.props.handleOpenOverlay();
  }

  handleCloseTooltip() {
    this.props.handleCloseOverlay();
  }

  render() {
    const { handleClick, handleCloseTooltip } = this;
    const {
      totalOccupants,
      enabledSelectors,
      ageRanges,
      fields,
      selectorsRange,
      childrenAgeRange,
      childrenCount,
      guestAges,
      onAgeSelectorChange,
      fullWidth,
      overlayIsOpen,
    } = this.props;

    return (
      <div
        className={classnames("wbkv9-OccupantsWrapper-OccupantsSelector", styles.occupantsSelector)}
        onClick={handleClick}>
        <div className={classnames("wbkv9-OccupantsWrapper-OccupantsIcon", styles.occupantsIcon)}>
          <OccupantsIcon />
        </div>

        <div className={classnames("wbkv9-OccupatnsWrapper-TotalOccupants", styles.totalOccupants)}>
          {totalOccupants}
        </div>

        <div className={classnames("wbkv9-OccupantsWrapper-arrowDown", styles.arrowDown)}>
          <ArrowDropDownIcon />
        </div>

        <TooltipOverlay
          placement="bottom"
          onHide={handleCloseTooltip}
          show={overlayIsOpen}
          container={this}
          rootClose
          style={(childrenCount > 0 && { height: 250 }) || null}>
          <OccupantsList
            enabledSelectors={enabledSelectors}
            ageRanges={ageRanges}
            fullWidth={fullWidth}
            fields={fields}
            selectorsRange={selectorsRange}
            childrenCount={childrenCount}
            guestAges={guestAges}
            childrenAgeRange={childrenAgeRange}
            onAgeSelectorChange={onAgeSelectorChange}
          />
        </TooltipOverlay>
      </div>
    );
  }
}

OccupantsWrapper.propTypes = {
  totalOccupants: PropTypes.number,
  enabledSelectors: PropTypes.array,
  fullWidth: PropTypes.bool,
  overlayIsOpen: PropTypes.bool,
  ageRanges: PropTypes.object,
  fields: PropTypes.object,
  selectorsRange: PropTypes.object,
  childrenAgeRange: PropTypes.object,
  childrenCount: PropTypes.number,
  guestAges: PropTypes.array,
  onAgeSelectorChange: PropTypes.func,
  handleOpenOverlay: PropTypes.func,
  handleCloseOverlay: PropTypes.func,
};

export default OccupantsWrapper;
